module.exports = __webpack_public_path__ + "static/media/the-interiors-group.f1ae2cab.png";